//@ts-check
import { Path, Svg } from '@react-pdf/renderer';
import qrcode from 'qrcode';
import React from 'react';
import { Box } from '.';

/**
 *
 * @param {qrcode.QRCodeToStringOptions & { url: string;  style?: import('@react-pdf/renderer').default.SVGProps["style"]}} props
 * @returns
 */
export default function QRCode({
  url,
  margin,
  errorCorrectionLevel = 'Q',
  style,
}) {
  const [qr, setQr] = React.useState({
    path: '',
    viewBox: '',
    svg: '',
  });
  if (qr.path) {
    return (
      <Svg viewBox={qr.viewBox} style={style}>
        <Path stroke="#000" d={qr.path} />
      </Svg>
    );
  }
  // We need to wait for the qr code to be generated. It's a fulfilled promise though, so we can immediately rerender.
  qrcode
    .toString(url, { margin, errorCorrectionLevel, type: 'svg' })
    .then((svg) => {
      const [, viewBox, path] =
        svg.match(/ viewBox="(.*)" shape.* d="(.*)"/) || [];
      if (!viewBox) {
        console.warn('no qrcode could be generated.');
        return;
      }
      return setQr({ viewBox, path, svg });
    });
  return <Box style={style} />;
}
